"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Charge = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { testID: "ChargeIcon", width: width, height: height, viewBox: "0 0 8.145 16.01" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, fillRule: "nonzero", d: "M 4.10419 9.04678 c -0.0948105 -0.10553 -0.229988 -0.165771 -0.371841 -0.165771 H 0 L 4.60497 0 l -0.690579 6.21521 c -0.0156937 0.141327 0.0295372 0.282654 0.124371 0.388611 c 0.0948334 0.105927 0.230301 0.166504 0.372494 0.166504 h 3.73343 l -4.61985 9.23969 l 0.704552 -6.57584 c 0.0151253 -0.141052 -0.0303879 -0.281891 -0.125198 -0.38739 Z" })));
};
Charge.defaultProps = {
    color: 'currentColor',
    width: 9,
    height: 16,
};
exports.default = react_1.default.memo(Charge);
